<div class="column" [class.column-sm]="column.static">
  <div>
    <span>{{ column.date | amDateFormat: 'll' }}</span>
    <span *ngIf="column.isDateAndTime">{{ column.date | amDateFormat: 'LT' }}</span>
  </div>
  <div *ngIf="!column.date" class="text-muted">-</div>
</div>
